import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Navbar from "../../components/Navbar";

// const API_BASE = 'http://localhost:5000/api';
const API_BASE = "http://192.168.0.57:5000/api";
// ─── THEME TOKENS ─────────────────────────────────────────────
const T = {
  bg:         '#0d0d0d',
  bgCard:     '#141414',
  // bgSection:  '#111111',
  bgSection:  'rgb(9, 9, 15)',
  border:     'rgba(201,168,76,0.18)',
  gold:       '#C9A84C',
  goldLight:  '#e8cc80',
  cream:      '#f0e6cc',
  textMuted:  'rgba(240,230,204,0.45)',
  textSub:    'rgba(240,230,204,0.65)',
  white:      '#ffffff',
};

// ─── NAVBAR ───────────────────────────────────────────────────
// function Navbar({ siteName }) {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [scrolled, setScrolled] = useState(false);
//   const navigate = useNavigate();

//   const NAV_LINKS = [
//     { label: 'Home',               href: '/' },
//     { label: 'Fleet',              href: '/our-cars' },
//     { label: 'Modify Reservation', href: '/modify-reservetion' },
//     { label: 'About',              href: '/about-us' },
//     { label: "Gallery",            href: "/gallery" },
//     { label: "Faq",            href: "/faqs" },
//     { label: 'Contact',            href: '/contact-us' },
//   ];

//   useEffect(() => {
//     const onScroll = () => setScrolled(window.scrollY > 40);
//     window.addEventListener('scroll', onScroll);
//     return () => window.removeEventListener('scroll', onScroll);
//   }, []);

//   const handleNav = (link) => {
//     if (link.href) navigate(link.href);
//     setMenuOpen(false);
//   };

//   return (
//     <>
//       <nav style={{
//         position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
//         display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//         padding: '0 2.5rem', height: '64px',
//         background: scrolled ? 'rgba(10,10,15,0.97)' : 'rgba(10,10,15,0.84)',
//         backdropFilter: 'blur(14px)',
//         borderBottom: `1px solid ${T.border}`,
//         boxShadow: scrolled ? '0 4px 24px rgba(0,0,0,0.6)' : 'none',
//         transition: 'all 0.3s ease',
//       }}>
//         {/* Logo */}
//         <div
//           onClick={() => navigate('/')}
//           style={{ cursor: 'pointer', fontFamily: 'Georgia, serif', fontSize: '1.25rem', fontWeight: '700', color: T.cream, letterSpacing: '0.5px' }}
//         >
//           Orisnz<span style={{ color: T.gold }}>{siteName?.replace('Drive','') || '-Fleet'}</span>
//         </div>

//         {/* Desktop links */}
//         <ul style={{ display: 'flex', gap: '2rem', margin: 0, padding: 0, listStyle: 'none' }}>
//           {NAV_LINKS.map(l => (
//             <li key={l.label}>
//               <a
//                 href={l.href || '#'}
//                 onClick={l.href ? (e) => { e.preventDefault(); handleNav(l); } : undefined}
//                 style={{ color: T.textSub, textDecoration: 'none', fontSize: '0.82rem', letterSpacing: '0.07em', textTransform: 'uppercase', fontWeight: '500', transition: 'color 0.2s' }}
//                 onMouseEnter={e => e.currentTarget.style.color = T.gold}
//                 onMouseLeave={e => e.currentTarget.style.color = T.textSub}
//               >
//                 {l.label}
//               </a>
//             </li>
//           ))}
//         </ul>

//         {/* Book Now CTA */}
//         <a
//           href="#bknengine"
//           style={{
//             border: `1px solid ${T.gold}`, color: T.gold,
//             padding: '7px 20px', borderRadius: '4px',
//             fontSize: '0.78rem', fontWeight: '600',
//             letterSpacing: '0.08em', textTransform: 'uppercase',
//             textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '6px',
//             transition: 'background 0.2s, color 0.2s',
//           }}
//           onMouseEnter={e => { e.currentTarget.style.background = T.gold; e.currentTarget.style.color = '#0d0d0d'; }}
//           onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = T.gold; }}
//         >
//           ← Home
//         </a>

//         {/* Mobile toggle */}
//         <button
//           onClick={() => setMenuOpen(o => !o)}
//           aria-label="Toggle menu"
//           style={{ display: 'none', flexDirection: 'column', gap: '5px', background: 'none', border: 'none', cursor: 'pointer', padding: '4px' }}
//           className="mob-toggle"
//         >
//           {[0,1,2].map(i => (
//             <span key={i} style={{
//               display: 'block', width: '22px', height: '2px',
//               background: T.gold, borderRadius: '2px',
//               transition: 'all 0.3s',
//               transform: menuOpen ? (i===0 ? 'rotate(45deg) translate(5px,5px)' : i===2 ? 'rotate(-45deg) translate(5px,-5px)' : '') : '',
//               opacity: menuOpen && i===1 ? 0 : 1,
//             }} />
//           ))}
//         </button>
//       </nav>

//       {/* Mobile menu */}
//       <div style={{
//         position: 'fixed', top: '64px', left: 0, right: 0, zIndex: 999,
//         background: 'rgba(13,13,13,0.98)',
//         borderBottom: `1px solid ${T.border}`,
//         display: 'flex', flexDirection: 'column',
//         padding: menuOpen ? '1.2rem 1.5rem' : '0 1.5rem',
//         maxHeight: menuOpen ? '400px' : '0',
//         overflow: 'hidden',
//         transition: 'max-height 0.35s ease, padding 0.3s',
//       }}>
//         {NAV_LINKS.map(l => (
//           <a
//             key={l.label}
//             href={l.href || '#'}
//             onClick={(e) => { if (l.href) { e.preventDefault(); handleNav(l); } else setMenuOpen(false); }}
//             style={{
//               color: T.textSub, textDecoration: 'none', fontSize: '0.92rem',
//               padding: '10px 0', borderBottom: `1px solid ${T.border}`,
//               letterSpacing: '0.05em',
//             }}
//           >
//             {l.label}
//           </a>
//         ))}
//         <a
//            href="#bknengine"
//           onClick={() => setMenuOpen(false)}
//           style={{
//             marginTop: '12px', textAlign: 'center',
//             border: `1px solid ${T.gold}`, color: T.gold,
//             padding: '9px', borderRadius: '4px',
//             fontSize: '0.82rem', fontWeight: '600',
//             letterSpacing: '0.08em', textTransform: 'uppercase',
//             textDecoration: 'none',
//           }}
//         >
//           Book Now
//         </a>
//       </div>
//     </>
//   );
// }

// ─── ABOUT US ─────────────────────────────────────────────────
const AboutUs = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    // Inject global styles matching the screenshot theme
    const s = document.createElement('style');
    s.id = 'about-us-styles';
    if (!document.getElementById('about-us-styles')) {
      s.innerHTML = `
        * { box-sizing: border-box; }
        body { background: #0d0d0d !important; margin: 0; }
        @keyframes spin    { to { transform: rotate(360deg); } }
        @keyframes fadeUp  { from { opacity:0; transform:translateY(20px); } to { opacity:1; transform:translateY(0); } }
        .about-animate     { animation: fadeUp 0.6s ease both; }

        .about-rich h1,
        .about-rich h2,
        .about-rich h3     { color: #C9A84C; font-family: Georgia, serif; margin: 2rem 0 0.75rem; line-height: 1.3; }
        .about-rich h1     { font-size: 1.9rem; }
        .about-rich h2     { font-size: 1.45rem; border-bottom: 1px solid rgba(201,168,76,0.2); padding-bottom: 0.5rem; }
        .about-rich h3     { font-size: 1.15rem; }
        .about-rich p      { color: rgba(240,230,204,0.72); line-height: 1.95; margin-bottom: 1.1rem; font-size: 0.97rem; }
        .about-rich strong { color: #e8cc80; }
        .about-rich em     { color: #C9A84C; font-style: italic; }
        .about-rich a      { color: #C9A84C; text-decoration: underline; }
        .about-rich ul,
        .about-rich ol     { color: rgba(240,230,204,0.72); padding-left: 1.5rem; margin-bottom: 1rem; line-height: 1.9; font-size: 0.97rem; }
        .about-rich li     { margin-bottom: 0.4rem; }
        .about-rich img    { max-width: 100%; border-radius: 6px; margin: 1.2rem 0; border: 1px solid rgba(201,168,76,0.2); }
        .about-rich blockquote {
          border-left: 3px solid #C9A84C;
          margin: 1.5rem 0; padding: 0.75rem 1.25rem;
          background: rgba(201,168,76,0.06);
          border-radius: 0 4px 4px 0;
          color: rgba(240,230,204,0.65);
          font-style: italic;
        }
        @media (max-width: 768px) {
          .mob-toggle { display: flex !important; }
          .desk-nav   { display: none !important; }
          .desk-cta   { display: none !important; }
          .about-hero-title { font-size: 2rem !important; }
          .about-grid { grid-template-columns: 1fr !important; }
        }
      `;
      document.head.appendChild(s);
    }

    axios.get(`${API_BASE}/contents/bypage`, {
      params: { page_name: 'about.php' },
      withCredentials: true,
    })
    .then(res => {
      const rows = res.data?.data;
      if (rows?.length > 0) setContent(rows[0]);
      setLoading(false);
    })
    .catch(() => { setError('Failed to load content.'); setLoading(false); });
  }, []);

  return (
    <div style={{ background: T.bg, minHeight: '100vh', fontFamily: "'Segoe UI', sans-serif" }}>
      {/* <Navbar siteName="Drive" /> */}
      <Navbar activePage="About" siteName="-Fleet" />
      {/* ── HERO SECTION ── */}
      <div style={{
        paddingTop: '64px',
        // background: `linear-gradient(180deg, #111 0%, ${T.bg} 100%)`,
        background: `linear-gradient(rgb(9, 9, 15) 0%, rgb(10, 14, 23) 100%)`,
        borderBottom: `1px solid ${T.border}`,
      }}>
        <div style={{ maxWidth: '960px', margin: '0 auto', padding: '64px 2rem 52px' }}>
          {/* Eyebrow */}
          <p style={{
            color: T.gold, fontSize: '0.72rem', letterSpacing: '0.28em',
            textTransform: 'uppercase', fontWeight: '600', margin: '0 0 14px',
          }}>
            Our Story
          </p>

          {/* Title */}
          <h1
            className="about-hero-title"
            style={{
              margin: '0 0 20px', lineHeight: 1.15,
              fontFamily: 'Georgia, serif',
              fontSize: '3.2rem', fontWeight: '700',
              color: T.white,
            }}
          >
            {loading ? 'About Us' : (content?.cont_title || 'About Us')}
          </h1>

          {/* Gold divider */}
          <div style={{
            width: '48px', height: '3px', borderRadius: '2px',
            background: `linear-gradient(90deg, ${T.gold}, ${T.goldLight})`,
            marginBottom: '20px',
          }} />

          {/* Breadcrumb */}
          <p style={{ color: T.textMuted, fontSize: '0.83rem', margin: 0 }}>
            Home &rsaquo;&nbsp;
            <span style={{ color: T.gold }}>{content?.cont_title || 'About Us'}</span>
          </p>
        </div>
      </div>

      {/* ── CONTENT SECTION ── */}
      <div style={{ background: T.bgSection }}>
        <div style={{ maxWidth: '960px', margin: '0 auto', padding: '56px 2rem 72px' }}>

          {/* Loading */}
          {loading && (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '5rem 0' }}>
              <div style={{
                width: '36px', height: '36px', borderRadius: '50%',
                border: `2px solid rgba(201,168,76,0.15)`,
                borderTop: `2px solid ${T.gold}`,
                animation: 'spin 0.8s linear infinite',
              }} />
            </div>
          )}

          {/* Error */}
          {error && (
            <div style={{
              background: 'rgba(180,50,50,0.1)', border: '1px solid rgba(180,50,50,0.3)',
              color: '#e88', borderRadius: '6px', padding: '1rem 1.5rem', textAlign: 'center',
            }}>
              {error}
            </div>
          )}

          {/* Empty */}
          {!loading && !error && !content && (
            <p style={{ color: T.textMuted, textAlign: 'center', padding: '4rem 0' }}>No content found.</p>
          )}

          {/* Content card */}
          {!loading && !error && content && (
            <div className="about-animate">
              {/* Info strip — matches the gold-bordered card style in screenshot */}
              <div style={{
                border: `1px solid ${T.border}`,
                borderLeft: `3px solid ${T.gold}`,
                background: 'rgba(201,168,76,0.05)',
                borderRadius: '6px',
                padding: '14px 20px',
                marginBottom: '2.5rem',
                display: 'flex', alignItems: 'center', gap: '12px',
              }}>
                <span style={{ color: T.gold, fontSize: '1.1rem' }}>ℹ</span>
                <p style={{ margin: 0, color: T.textSub, fontSize: '0.87rem', lineHeight: 1.6 }}>
                  Welcome to <strong style={{ color: T.gold }}>Orisnz Fleet</strong> — your trusted car rental partner.
                </p>
              </div>

              {/* Rich HTML content from DB */}
              <div
                className="about-rich"
                dangerouslySetInnerHTML={{ __html: content.cont_details }}
              />
            </div>
          )}

          {/* Bottom rule */}
          {!loading && (
            <div style={{
              borderTop: `1px solid ${T.border}`,
              marginTop: '4rem', paddingTop: '1.5rem',
              textAlign: 'center',
            }}>
              <span style={{ color: 'rgba(201,168,76,0.35)', fontSize: '0.75rem', letterSpacing: '0.18em', textTransform: 'uppercase' }}>
                Orisnz Fleet &mdash; Orisys Infotech Pvt. Ltd
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AboutUs;